var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content"},[_c('Slider'),_c('section',{staticClass:"ShowsList"},_vm._l((_vm.TotalShows),function(shows,index){return _c('ShowsList',{key:index,attrs:{"title":shows.ListTitle,"shows":shows.Shows}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }